import React from 'react';
import { useHistory } from 'react-router-dom';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';
import { useQuery } from '@tanstack/react-query';
import { CandidateExperienceQueryKeys } from 'api/query_keys';

import { getEmployeeOffers } from '../employee_requests';

export function OfferList(): JSX.Element {
  const history = useHistory();
  const { data: assignedOffers } = useQuery({
    queryKey: [CandidateExperienceQueryKeys.EMPLOYEE_OFFERS],
    queryFn: () => getEmployeeOffers(history),
  });

  if (!assignedOffers) {
    return <Typography variant="body">Loading offers...</Typography>;
  }

  return (
    <Flex className="offer-list" direction="column" gap="md">
      <ul>
        {assignedOffers.offers.map((offer) => (
          <li key={offer.candidateEmail}>
            <a href={`/web_offer/${offer.candidateEmail}`}>
              {offer.candidateFirstName} {offer.candidateLastName}
            </a>
          </li>
        ))}
      </ul>
    </Flex>
  );
}
